// extracted by mini-css-extract-plugin
export var bgImage = "CaseStudies-module--bg-image--e31ee";
export var content = "CaseStudies-module--content--77039";
export var image = "CaseStudies-module--image--e1cc9";
export var link = "CaseStudies-module--link--4447d";
export var video = "CaseStudies-module--video--cc90a";
export var videoContainer = "CaseStudies-module--video-container--70cd1";